var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('pie-chart',{attrs:{"title":"Répartition des articles","subTitle":"par sessions générées","series":_vm.series,"labels":_vm.labels,"loading":_vm.loading,"formatter":_vm.formatter,"outlined":""}})}
var staticRenderFns = []

export { render, staticRenderFns }